import {
	TRIGGER_INITIATE_PREPAID_PAYMENT_API_CALL,
	TRIGGER_INITIATE_PREPAID_PAYMENT_API_CALL_SUCCESS,
} from 'redux/actionTypes';

export function triggerInitiatePrePaidPaymentApiCall(data, callback, stopLoader) {
	return {
		type: TRIGGER_INITIATE_PREPAID_PAYMENT_API_CALL,
		data,
		stopLoader,
		callback,
	};
}

export function triggerInitiatePrePaidPaymentApiCallSuccess(data) {
	return {
		type: TRIGGER_INITIATE_PREPAID_PAYMENT_API_CALL_SUCCESS,
		data,
	};
}
